import * as React from "react";

export const AlertIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.8"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 2L22 20H2L12 2ZM11 8H13V14H11V8ZM13 16V18H11V16H13Z"
      fill="#E64595"
    />
  </svg>
);
